export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-copy">
        <strong>Nesty Learning</strong>
        <span>Free core child-learning path. Designed to sit alongside Nesty.family.</span>
      </div>
      <nav className="site-footer-links" aria-label="Related Snoaper family products">
        <span>Also by Snoaper:</span>
        <a href="https://familymacro.com/" rel="noopener">FamilyMacro</a>
        <a href="https://familymacro.com/family-nutrition-tracker/" rel="noopener">family nutrition tracker</a>
      </nav>
    </footer>
  );
}
